var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoArrowDownGray16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1209_17689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.5,
    width: 16,
    height: 16,
    transform: "rotate(-180 16 16.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1209_17689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5333 6.69997C11.6556 6.82219 11.7167 6.97774 11.7167 7.16663C11.7167 7.35552 11.6556 7.51108 11.5333 7.6333L8.46667 10.7C8.40001 10.7666 8.32779 10.8139 8.25001 10.8416C8.17223 10.8694 8.0889 10.8833 8.00001 10.8833C7.91112 10.8833 7.82501 10.8666 7.74167 10.8333C7.65834 10.8 7.5889 10.7555 7.53334 10.7L4.46667 7.6333C4.34445 7.51108 4.28334 7.35552 4.28334 7.16663C4.28334 6.97774 4.34445 6.82219 4.46667 6.69997C4.5889 6.57774 4.74445 6.51663 4.93334 6.51663C5.12223 6.51663 5.27779 6.57774 5.40001 6.69997L8.00001 9.29997L10.6 6.69997C10.7222 6.57774 10.8778 6.51663 11.0667 6.51663C11.2556 6.51663 11.4111 6.57775 11.5333 6.69997Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDownGray16);
export default __webpack_public_path__ + "static/media/ico_arrow_down_gray_16.7eb796cee6d293c2527edbf2f1388a54.svg";
export { ForwardRef as ReactComponent };